export const TEAM_ROLES = ["admin", "veterinary", "groomer", "receptionist", "pet_sitter"] as const;
export type EditableRole = (typeof TEAM_ROLES)[number];

export const TEAM_ACTIONS = ["view", "create", "update", "delete"] as const;
export type TeamAction = (typeof TEAM_ACTIONS)[number];

/** Legacy features with no screen of their own; kept working by role templates, hidden in the matrix. */
export const TEAM_HIDDEN_FEATURES: ReadonlySet<string> = new Set([
  "admin_permissions", "admin_users", "user_access", "user_permission",
]);

/** Module list taken from public.modules on 2026-10-02. */
export const TEAM_MODULE_ORDER = [
  "core", "financial", "financial_ledger", "grooming", "day_care", "hotel", "hospitalization", "stock", "flowboard", "whatsapp", "fiscal", "erp",
] as const;

/** Every feature in public.features on 2026-10-02 plus team/commissions. */
export const TEAM_KNOWN_FEATURES = [
  "admin_permissions", "admin_users", "applications", "appointments", "audit_logs", "calendar", "catalog",
  "commissions", "daycare", "financial_cashbox", "financial_ledger", "financial_overview", "financial_payables",
  "financial_receivables", "financial_reports", "flowboard", "grooming", "grooming_packages", "hospitalization",
  "hospitalization_config", "hotel", "manage_clinic", "medical_records", "patient_financial", "patients", "purchases",
  "reports", "sales", "stock", "team", "terms", "user_access", "user_permission", "whatsapp_config",
] as const;
